/* global axios */
import ApiClient from './ApiClient';

class ListingImportsAPI extends ApiClient {
  constructor() {
    super('listing_import_runs', { accountScoped: true });
  }

  runs(params = {}) {
    return axios.get(this.url, { params });
  }

  showRun(id) {
    return axios.get(`${this.url}/${id}`);
  }

  retryRun(id, payload = {}) {
    return axios.post(`${this.url}/${id}/retry`, payload);
  }

  releaseRunQuarantine(id, payload = {}) {
    return axios.post(`${this.url}/${id}/release_quarantine`, payload);
  }

  reviewTombstoneCandidates(id, payload = {}) {
    return axios.post(`${this.url}/${id}/tombstone_candidates/review`, payload);
  }

  rawRecordUrl(id) {
    return `${this.baseUrl()}/listing_raw_records/${id}`;
  }

  showRawRecord(id) {
    return axios.get(this.rawRecordUrl(id));
  }

  replayRawRecord(id, payload = {}) {
    return axios.post(`${this.rawRecordUrl(id)}/replay`, payload);
  }

  releaseRawRecordQuarantine(id, payload = {}) {
    return axios.post(`${this.rawRecordUrl(id)}/release_quarantine`, payload);
  }

  drifts(params = {}) {
    return axios.get(`${this.baseUrl()}/listing_import_drifts`, { params });
  }

  reviewDrift(id, action, payload = {}) {
    return axios.post(
      `${this.baseUrl()}/listing_import_drifts/${id}/${action}`,
      payload
    );
  }
}

export default new ListingImportsAPI();
